/* Emotion Styled Components */
// Media Queries

var mediaQueryMin = function mediaQueryMin(value) {
  return "@media(min-width: ".concat(value, "px)");
};
var mediaQueryMax = function mediaQueryMax(value) {
  return "@media(max-width: ".concat(value, "px)");
};
export var max1000 = mediaQueryMax(1000);
export var max1200 = mediaQueryMax(1200);
export var max1300 = mediaQueryMax(1300);
export var max1440 = mediaQueryMax(1440); // mac laptop 13'
export var max1441 = mediaQueryMax(1441);
export var max375 = mediaQueryMax(375);
export var max410 = mediaQueryMax(410);
export var max425 = mediaQueryMax(425);
export var max445 = mediaQueryMax(445);
export var max487 = mediaQueryMax(487);
export var max500 = mediaQueryMax(500);
export var max548 = mediaQueryMax(548);
export var max600 = mediaQueryMax(600);
export var max768 = mediaQueryMax(768);
export var max920 = mediaQueryMax(920);
export var max992 = mediaQueryMax(992);
export var min1440 = mediaQueryMin(1440);
export var min1200 = mediaQueryMin(1200);
export var min500 = mediaQueryMin(500);
export var min768 = mediaQueryMin(768);
export var min992 = mediaQueryMin(992);